// The words printed under the Photo Vivante QR on the back cover (customer
// copy, French). Its own module so the PDF generator never imports the API.
export const LIVING_BACK_TEXT = 'Scannez-moi : votre souvenir prend vie';
